import { render, staticRenderFns } from "./indexWork.vue?vue&type=template&id=90109342&"
import script from "./indexWork.vue?vue&type=script&lang=ts&"
export * from "./indexWork.vue?vue&type=script&lang=ts&"
import style0 from "./indexWork.vue?vue&type=style&index=0&id=90109342&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports